import { FeatureFlags } from "../../../../Forms/Types/FeatureFlags";

export enum FeatureFlagsActionType {
    LoadInitialFeatureFlags = "LoadInitialFeatureFlags",
}

export interface FeatureFlagsAction {
    type: FeatureFlagsActionType.LoadInitialFeatureFlags;
    payload: FeatureFlags;
}
